<template>
    <div class="login-container">
      <img src="@/assets/bobw-logo.png" alt="BoBW Logo" class="logo" />
      <h2>BoBW Band Login</h2>
      <form v-if="!isLoggedIn" @submit.prevent="login">
        <div class="input-group">
          <input type="text" id="username" v-model="username" placeholder="Username" required />
        </div>

        <div class="input-group">
          <input v-model="password" type="password" placeholder="Password" required />
        </div>
        <button type="submit" class="login-btn">Login</button>
      </form>

      <p v-if="error" style="color: red;">{{ error }}</p>

      
      <div v-if="isLoggedIn" class="logged-in-container">
        <p>Welcome, {{ username }}...let's rock!</p>

        <router-link to="/submit-songs">
          <button class="nav-button">Submit Songs</button>
        </router-link>

        <router-link to="/vote-songs">
          <button class="nav-button">Vote on Songs</button>
        </router-link>

        <router-link to="/song-results">
          <button class="nav-button">View Results</button>
        </router-link>

        <button class="logout-button" @click="logout">Logout</button>
      </div>
    </div>
  </template>
  
  <script>
  import { useRouter } from "vue-router";
  
  export default {
    data() {
      return { username: "", password: "", error: null, isLoggedIn: false };
    },
    setup() {
      const router = useRouter();
      return { router };
    },
    mounted() {
      const storedUser = localStorage.getItem("bandUser")
      if (storedUser) {
        this.username = storedUser;
        this.isLoggedIn = true;
      }
    },
    methods: {
      async login() {
        try {
          const response = await fetch("https://zmrukyt38a.execute-api.us-west-2.amazonaws.com/v1/login", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ username: this.username, password: this.password }),
          });

          const result = await response.json();

          if (result.success) {
              alert("✅ Login successful!");
              // Save session info (later we'll handle this better)
              localStorage.setItem("bandUser", this.username);
              // Display buttons
              this.isLoggedIn = true;
          } else {
              alert("❌ Login failed: " + result.error);
        }
        } catch (error) {
            console.error("❌ Login error:", error);
            alert("❌ Something went wrong. Try again.");
        }
      },
      logout() {
        localStorage.removeItem("bandUser")
        this.isLoggedIn = false;
        this.username = "";
      }
    }
  };
  </script>
  
<style scoped>
.logo {
  width: 200px;
  height: auto;
  margin-bottom: 15px;
}

form {
  display: flex;
  flex-direction: column;
  align-items: center;   /* This centers the inputs & button horizontally */
  width: 100%;
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh; /* Center on the screen */
  background: #121212; /* Dark theme for a band vibe */
  color: white;
  text-align: center;
}

.input-group {
  width: 100%;
  max-width: 250px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

input {
  padding: 10px;
  font-size: 16px;
  border-radius: 5px;
  border: none;
  outline: none;
  width: 100%;
}

/* Stack buttons after login */
.logged-in-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
}

.login-btn {
  padding: 10px;
  font-size: 18px;
  background: #e63946; /* Rock band red */
  color: white;
  border: none;
  cursor: pointer;
  width: 100%;
  max-width: 250px;
  border-radius: 5px;
  transition: 0.3s ease;
}

.login-btn:hover {
  background: #d62828;
}

/* 🎸 After Login: Navigation Buttons */
.button-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}

/* 🎤 Song Navigation Buttons */
.nav-button, .logout-btn {
  background: #e63946;
  color: white;
  text-decoration: none;
  padding: 12px;
  margin: 5px;
  width: 220px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  transition: 0.3s ease;
}

.nav-button:hover, .logout-btn:hover {
  background: #d62828;
}

/* 🚪 Logout Button */
.logout-button {
  padding: 10px;
  font-size: 18px;
  background: #222; /* Rock band red */
  color: white;
  border: none;
  cursor: pointer;
  width: 100%;
  max-width: 300px;
  border-radius: 5px;
  transition: 0.3s ease;
}

.logout-button:hover {
  background: #d62828;
}

/* 🎶 Welcome Message */
.welcome-message {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.error-message {
  color: red;
}

</style>